import { logger } from '../../../../utils/common/logger'

interface IWindow extends Window {
    Sailthru: {
        integration: (eventName: string, options: any) => {}
        init(options: { customerId: string }): void
    }
}

interface ISailthruUserSignUpOptions {
    email: string,
    lists: Record<string, number>,
    onError: () => void,
    onSuccess: () => void,
    vars?: Record<string, unknown>
}

declare let window: IWindow

export default class SailthruAdapter {

    public static socialRegListId = 'Social_Reg'

    // tslint:disable-next-line:no-empty
    constructor() {
    }

    /**
     * Set cookie with userSignUp from the Sailthru JS Library
     * This automatically sets the cookie
     * We return Promise here so that we can await this function call.
     * Reference: https://getstarted.sailthru.com/developers/api-client/javascript/#userSignUp
     *
     * @param email: string - user email
     */
    public static async setCookie(email: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (window.Sailthru) {
                window.Sailthru.integration('userSignUp', {
                    email,
                    lists: {},
                    onError: (err: any) => {
                        logger('error', 'Sailthru cookie set failed', err)
                        reject()
                    },
                    onSuccess: () => {
                        logger('info', 'Sailthru cookie set successfully')
                        resolve()
                    }
                })
            } else {
                logger('error', 'Sailthru is not available. Can\'t set the cookie.')
                reject()
            }
        })
    }

    /**
     * Add email to a Sailthru mailing list
     * We return Promise here so that we can await this function call.
     *
     * @param email string
     * @param listId string
     * @param vars Record<string, unknown>
     */

    public static async addToEmailList(email: string, listId: string, vars?: Record<string, unknown>): Promise<void> {
        return new Promise((resolve, reject) => {
            let options =  {
                email,
                lists: {
                    [listId]: 1
                },
                onError: (err: any) => {
                    logger('error', `Sailthru add to ${listId} list failed`, err)
                    reject()
                },
                onSuccess: () => {
                    logger('info', `Sailthru add to ${listId} list successfull`)
                    resolve()
                }
            } as ISailthruUserSignUpOptions

            if (vars) {
                options = {...options, vars}
            }

            if (window.Sailthru) {
                window.Sailthru.integration('userSignUp', options)
            } else {
                logger('error', 'Sailthru is not available. Can\'t add to Sailthru list.')
                reject()
            }
        })
    }
}
